import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje, MensajeSiNo } from '../../mensajes';
import { Dimmer } from "../../spinner";
import '../../../dist/css/smart_wizard.css';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import CatalogoOrganizacion from '../../../catalogos/catalogoOrganizacion';
import CatalogoPersona from '../../../catalogos/catalogoPersona';
import {
    validaSoloNumero, validaMonto, formatoMonto,
    seleccionarCampo, validaNumeroTelefono, validaEmail
} from '../../../util/varios';
export const ActualizarUsuarioFact = (props) => {

    /*  variables de estados */

    const btnCancela = useRef();
    const btnAcepta = useRef();
    const btnEnviar = useRef();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar1, setMostrar1] = useState(false);
    const [mostrar2, setMostrar2] = useState(false);
    const [mostrar3, setMostrar3] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [contar, setContar] = useState(0);
    const [contar2, setContar2] = useState(0);
    const [titulo2, setTitulo2] = useState();
    const [msg2, setMsg2] = useState();
    const [dato, setDato] = useState([3]);
    const [dato2, setDato2] = useState('');
    const [password, setPassword] = useState('');
    const [activate, setActivate] = useState(false);
    const [usuario, setUsuario] = useState();
    const [organizacion, setOrganizacion] = useState({ idorganizacion: '', razonsocial: '' });
    const [persona, setPersona] = useState({ cedula: '', nombres: '', apellidos: '', direccion: '', correoe: '', tlf1: '', tlf2: '', fnacimiento: '', nacionalidad: '', sexo: '' });
    const [mostrarClave, setMostrarClave] = useState(false);
    const [mostrarClave1, setMostrarClave1] = useState(false);
    const [correo, setCorreo] = useState('');
    const [modulos, setModulos] = useState({
        accedocuenta: '0',
        accrenovalicencia: '0',
        acclicenciafunciona: '0',
        accpermdecla: '0',
        accacreditacion: '0',
        accexoncomercio: '0',
        accverifica: '0',
        accconfigcome: '0',
        accrepgensector: '0',
        accreppatente: '0',
        accrepactividad: '0',
        accrepfecdecla: '0',
        accrepmondecla: '0',
        accimppatente: '0',
        accimpedoctasectcome: '0',
        accimptramites: '0',
    });
    const [permisos, setPermisos] = useState({
        acccontribuyente: '0000',
        accactividad: '0000',
        accdeclaraciones: '000',
        accacticontri: '00',
        accagente: '0000',
        accusuariocome: '0000',
    });

    const [url, setUrl] = useState('');

    let op = require('../../../../src/modulos/datos');
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [habilitadoNU, setHabilitadoNU] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [operacionPer, setOperacionPer] = useState(0);
    const [tecla, setTecla] = useState();
    const [tabIndex, setTabIndex] = useState(0);
    const [tabIndex1, setTabIndex1] = useState(0);
    const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
    const [desde, setDesde] = useState(0);
    const txtIdUsuario = useRef();
    const txtLogin = useRef();
    const txtPassword = useRef();
    const txtConfirmPassword = useRef();
    const txtIdOrg = useRef();
    const txtNomOrg = useRef();
    const txtCedula = useRef();
    const txtNombreUsuario = useRef();
    const txtApellidoUsuario = useRef();
    const txtDireccionUsuario = useRef();
    const txtEmailUsuario = useRef();
    const txtTlfUsuario = useRef();
    const txtCelUsuario = useRef();
    const txtFechaNac = useRef();
    const cmbNacionalidad = useRef();
    const cmbSexo = useRef();
    const chkLiquidador = useRef();
    const chkPoseeImpresora = useRef();
    const radioPuertoU = useRef();
    const radioPuertoP = useRef();
    const radioPuertoS = useRef();

    useEffect(() => {
        let obj = JSON.parse(localStorage.getItem('post'));
//setFechaSistema(obj[0].fechasistema);
        /*var nanio = []
        var aini = parseInt(obj[0].anioactu) - 7;
        var afin = parseInt(obj[0].anioactu);
        for (let i = 1; i <= afin - aini; i++) {
            nanio.push({ anio: aini + i });

        }
        setAnio(nanio);*/
        if (props.operacion) {
            setOperacion(props.operacion);
        }

        if (op.reportes != null) {

            setUrl(op.reportes.trim());

        } else {
            setUrl('');
        }

    }, [props.operacion]);

    useEffect(() => {

        if (contar === 0) {
            if (errorOrg) {

                let obj = JSON.parse(JSON.stringify(errorOrg));

                setTitulo("Error");
                setMsg(obj.message.replace('GraphQL error: ', '').replace('Network error: ', ''));
                setMostrar(true);
                setContar(contar + 1);
            }
        }

        if (contar === 0) {
            if (errorRes) {

                let obj = JSON.parse(JSON.stringify(errorRes));

                setTitulo("Error");
                setMsg(obj.message.replace('GraphQL error: ', '').replace('Network error: ', ''));
                setMostrar(true);
                setContar(contar + 1);
            }
        }

        if (contar2 === 0) {
            if (errorReg) {
                setActivate(false);
                let obj = JSON.parse(JSON.stringify(errorReg));

                setTitulo("Error");
                setMsg(obj.message.replace('GraphQL error: ', '').replace('Network error: ', ''));
                setMostrar(true);
                setContar2(contar2 + 1);
            }
        }

    });

  
   
  
    const validarOrg = (event) => {
        validaSoloNumero(event);
        //txtNomOrg.current.value = "";
        //txtNombreRep.current.value = "";
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {
                setContar(0);
                //setActivate(true);


            } else {
                txtNomOrg.current.value = '';
                txtIdOrg.current.value = '';
            }
        }
    };

    const handleCloseCatalogo = () => {
        setMostrar2(false);
    };

    const handleAceptaCatalogo = (idOrg, nomOrg, razonOrg) => {
        setMostrar2(false);
        txtIdOrg.current.value = idOrg;
        txtNomOrg.current.value = nomOrg;
    };

    const catalogoOrg = () => {
        if (operacion < 3) {
            setMostrar2(true);
        }

    };

    const handleCloseCatalogoPer = () => {
        setMostrar3(false);
    }

    const handleAceptaCatalogoPer = (cedPer, nomPer, apePer, correoPer, tlf1Per,
        tlf2Per, fnacPer, nacPer, sexoPer, direPer) => {
        setMostrar3(false);
        txtCedula.current.value = cedPer;
        txtNombreUsuario.current.value = nomPer;
        txtApellidoUsuario.current.value = apePer;
        txtDireccionUsuario.current.value = direPer;
        txtEmailUsuario.current.value = correoPer;
        txtTlfUsuario.current.value = tlf1Per;
        txtCelUsuario.current.value = tlf2Per;
        txtFechaNac.current.value = fnacPer;
        cmbNacionalidad.current.value = nacPer;
        cmbSexo.current.value = sexoPer;
        btnAcepta.current.focus();
    }

    const catalogoPer = (e) => {
        e.preventDefault();
        if (operacion < 3) {
            setMostrar3(true);
        }

    };

    /* metodo para restablecer los valores  a su estado inicial */


    const blanquear = () => {

        setMostrar(false);
        setTitulo('');
        setMsg('');
        setMostrar1(false);
        setTitulo2('');
        setMsg2('');
        setDato([3]);
        setDato2('');
        setPassword('');
        setActivate(false);
        setCorreo('');
        setDesde(0);
        setModulos({
            accedocuenta: '0',
            accrenovalicencia: '0',
            acclicenciafunciona: '0',
            accpermdecla: '0',
            accacreditacion: '0',
            accexoncomercio: '0',
            accverifica: '0',
            accconfigcome: '0',
            accrepgensector: '0',
            accreppatente: '0',
            accrepactividad: '0',
            accrepfecdecla: '0',
            accrepmondecla: '0',
            accimppatente: '0',
            accimpedoctasectcome: '0',
            accimptramites: '0',
        });
        setPermisos({
            acccontribuyente: '0000',
            accactividad: '0000',
            accdeclaraciones: '000',
            accacticontri: '00',
            accagente: '0000',
            accusuariocome: '0000',
        });

    }


    const handleCloseNo = () => {
        setMostrar1(false);
        if (msg2 === "Esta seguro de recuperar la clave?") {
            setDato([3])
        }
    };

    /* metodo para cerrar la notificacion */


    const handleCloseMensa = (e) => {
        e.preventDefault();
        setMostrar(false);
        if (desde === 3) {
            setDesde(0);
            props.onHideAcepta();
        }

        setDesde(0);

    }



    const cancelar = () => {

        blanquear();

        props.onHideCancela();
    }

    const handleChangeOtro = (event) => {

        setModulos({ ...modulos, [event.target.name]: event.target.value === 'true' ? '1' : '0' });
    };

    const handleChangeChek = (event) => {

        var num;
        num = event.target.checked === true ? '1' : '0';

        if (event.target.name === 'acccontribuyente') {

            if (event.target.id === 'chkRegContriConsul') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        num
                        + permisos.acccontribuyente.toString().substring(1, 2)
                        + permisos.acccontribuyente.toString().substring(2, 3)
                        + permisos.acccontribuyente.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkRegContriInc') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.acccontribuyente.toString().substring(0, 1)
                        + num
                        + permisos.acccontribuyente.toString().substring(2, 3)
                        + permisos.acccontribuyente.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkRegContriEdit') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.acccontribuyente.toString().substring(0, 1)
                        + permisos.acccontribuyente.toString().substring(1, 2)
                        + num
                        + permisos.acccontribuyente.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkRegContriElim') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.acccontribuyente.toString().substring(0, 1)
                        + permisos.acccontribuyente.toString().substring(1, 2)
                        + permisos.acccontribuyente.toString().substring(2, 3)
                        + num
                });

            } else if (event.target.id === 'chkRegContriTodo') {

                setPermisos({
                    ...permisos,
                    [event.target.name]: event.target.checked ? '1111' : '0000'
                });

            }


        } else if (event.target.name === 'accactividad') {

            if (event.target.id === 'chkActiviEconoConsul') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        num
                        + permisos.accactividad.toString().substring(1, 2)
                        + permisos.accactividad.toString().substring(2, 3)
                        + permisos.accactividad.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkActiviEconoInc') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accactividad.toString().substring(0, 1)
                        + num
                        + permisos.accactividad.toString().substring(2, 3)
                        + permisos.accactividad.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkActiviEconoEdit') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accactividad.toString().substring(0, 1)
                        + permisos.accactividad.toString().substring(1, 2)
                        + num
                        + permisos.accactividad.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkActiviEconoElim') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accactividad.toString().substring(0, 1)
                        + permisos.accactividad.toString().substring(1, 2)
                        + permisos.accactividad.toString().substring(2, 3)
                        + num
                });

            } else if (event.target.id === 'chkActiviEconoTodo') {

                setPermisos({
                    ...permisos,
                    [event.target.name]: event.target.checked ? '1111' : '0000'
                });

            }


        } else if (event.target.name === 'accdeclaraciones') {

            if (event.target.id === 'chkDeclaracionesInc') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        num
                        + permisos.accdeclaraciones.toString().substring(1, 2)
                        + permisos.accdeclaraciones.toString().substring(2, 3)
                });

            } else if (event.target.id === 'chkDeclaracionesElim') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accdeclaraciones.toString().substring(0, 1)
                        + num
                        + permisos.accdeclaraciones.toString().substring(2, 3)
                });

            } else if (event.target.id === 'chkDeclaracionesCar') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accdeclaraciones.toString().substring(0, 1)
                        + permisos.accdeclaraciones.toString().substring(1, 2)
                        + num
                });

            }


        } else if (event.target.name === 'accacticontri') {

            if (event.target.id === 'chkUsuarioWebInc') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        num
                        +
                        permisos.accacticontri.toString().substring(1, 2)
                });

            } else if (event.target.id === 'chkUsuarioWebElim') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accacticontri.toString().substring(0, 1)
                        + num
                });

            } else if (event.target.id === 'chkUsuarioWebTodo') {

                setPermisos({
                    ...permisos,
                    [event.target.name]: event.target.checked ? '11' : '00'
                });
            }

        } else if (event.target.name === 'accusuariocome') {

            if (event.target.id === 'chkUsuarioComeConsul') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        num
                        + permisos.accusuariocome.toString().substring(1, 2)
                        + permisos.accusuariocome.toString().substring(2, 3)
                        + permisos.accusuariocome.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkUsuarioComeInc') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accusuariocome.toString().substring(0, 1)
                        + num
                        + permisos.accusuariocome.toString().substring(2, 3)
                        + permisos.accusuariocome.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkUsuarioComeEdit') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accusuariocome.toString().substring(0, 1)
                        + permisos.accusuariocome.toString().substring(1, 2)
                        + num
                        + permisos.accusuariocome.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkUsuarioComeElim') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accusuariocome.toString().substring(0, 1)
                        + permisos.accusuariocome.toString().substring(1, 2)
                        + permisos.accusuariocome.toString().substring(2, 3)
                        + num
                });

            } else if (event.target.id === 'chkUsuarioComeTodo') {

                setPermisos({
                    ...permisos,
                    [event.target.name]: event.target.checked ? '1111' : '0000'
                });
            }


        } else if (event.target.name === 'accagente') {

            if (event.target.id === 'chkOrganismoConsul') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        num
                        + permisos.accagente.toString().substring(1, 2)
                        + permisos.accagente.toString().substring(2, 3)
                        + permisos.accagente.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkOrganismoInc') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accagente.toString().substring(0, 1)
                        + num
                        + permisos.accagente.toString().substring(2, 3)
                        + permisos.accagente.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkOrganismoEdit') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accagente.toString().substring(0, 1)
                        + permisos.accagente.toString().substring(1, 2)
                        + num
                        + permisos.accagente.toString().substring(3, 4)
                });

            } else if (event.target.id === 'chkOrganismoElim') {

                setPermisos({
                    ...permisos,
                    [event.target.name]:
                        permisos.accagente.toString().substring(0, 1)
                        + permisos.accagente.toString().substring(1, 2)
                        + permisos.accagente.toString().substring(2, 3)
                        + num
                });

            } else if (event.target.id === 'chkOrganismoTodo') {

                setPermisos({
                    ...permisos,
                    [event.target.name]: '1111'
                });

            }

        }
    }

    const handleInputChange = (event) => {
        if (event.which === 13) {
            var valido;
            if (event.target.id === 'inputCodigo') {
                txtLogin.current.focus();
            } else if (event.target.id === 'inputLogin') {
                txtPassword.current.focus();
            } else if (event.target.id === 'inputPassword') {
                if (txtConfirmPassword.current.value !== '' && txtPassword.current.value !== txtConfirmPassword.current.value) {
                    setTitulo('Información');
                    setMsg('Las Contraseñas no coinciden.');
                    setMostrar(true);
                    txtPassword.current.focus();
                } else {
                    txtConfirmPassword.current.focus();
                }

            } else if (event.target.id === 'inputConfirmPassword') {
                if (txtConfirmPassword.current.value !== '' && txtPassword.current.value !== txtConfirmPassword.current.value) {
                    setTitulo('Información');
                    setMsg('Las Contraseñas no coinciden.');
                    setMostrar(true);
                    txtConfirmPassword.current.focus();
                } else {
                    txtIdOrg.current.focus();
                }

            } else if (event.target.id === 'inputNomUsuario') {
                txtApellidoUsuario.current.focus();
            } else if (event.target.id === 'inputApeUsuario') {
                txtDireccionUsuario.current.focus();
            } else if (event.target.id === 'inputDireUsuario') {
                txtEmailUsuario.current.focus();
            } else if (event.target.id === 'inputEmailUsuario') {
                valido = validaEmail(event.target.value);
                if (valido) {
                    txtTlfUsuario.current.focus();
                } else {
                    if (event.target.value !== '') {
                        setTitulo('Información');
                        setMsg('Formato de Email invalido.');
                        setMostrar(true);
                        event.target.value = '';
                    } else {
                        txtTlfUsuario.current.focus();
                    }
                }

            } else if (event.target.id === 'inputTlfUsuario') {
                valido = validaNumeroTelefono(event.target.value);
                if (valido) {
                    txtCelUsuario.current.focus();
                } else {
                    if (event.target.value !== '') {
                        setTitulo('Información');
                        setMsg('Formato de número telefonico invalido.');
                        setMostrar(true);
                        event.target.value = '';
                    } else {
                        txtCelUsuario.current.focus();
                    }
                }
            } else if (event.target.id === 'inputCelUsuario') {
                valido = validaNumeroTelefono(event.target.value);
                if (valido) {
                    txtFechaNac.current.focus();
                } else {
                    if (event.target.value !== '') {
                        setTitulo('Información');
                        setMsg('Formato de número telefonico invalido.');
                        setMostrar(true);
                        event.target.value = '';
                    } else {
                        txtFechaNac.current.focus();
                    }
                }
            } else if (event.target.id === 'inputFechaNac') {
                cmbNacionalidad.current.focus();
            }
        } else if (typeof (event.which) === 'undefined') {
            if (event.target.id === 'inputPassword') {
                if (txtConfirmPassword.current.value !== '' && txtPassword.current.value !== txtConfirmPassword.current.value) {
                    setTitulo('Información');
                    setMsg('Las Contraseñas no coinciden.');
                    setMostrar(true);
                }
            } else if (event.target.id === 'inputConfirmPassword') {
                if (txtConfirmPassword.current.value !== '' && txtPassword.current.value !== txtConfirmPassword.current.value) {
                    setTitulo('Información');
                    setMsg('Las Contraseñas no coinciden.');
                    setMostrar(true);
                }

            } else if (event.target.id === 'inputEmailUsuario') {
                valido = validaEmail(event.target.value);
                if (valido) {
                    txtTlfUsuario.current.focus();
                } else {
                    if (event.target.value !== '') {
                        setTitulo('Información');
                        setMsg('Formato de Email invalido.');
                        //setMostrar(true);
                        event.target.value = '';
                    } else {
                        txtTlfUsuario.current.focus();
                    }
                }

            } else if (event.target.id === 'inputTlfUsuario') {
                valido = validaNumeroTelefono(event.target.value);
                if (valido) {
                    txtCelUsuario.current.focus();
                } else {
                    if (event.target.value !== '') {
                        setTitulo('Información');
                        setMsg('Formato de número telefonico invalido.');
                        //setMostrar(true);
                        event.target.value = '';
                    } else {
                        txtCelUsuario.current.focus();
                    }
                }
            } else if (event.target.id === 'inputCelUsuario') {
                valido = validaNumeroTelefono(event.target.value);
                if (valido) {
                    txtFechaNac.current.focus();
                } else {
                    if (event.target.value !== '') {
                        setTitulo('Información');
                        setMsg('Formato de número telefonico invalido.');
                        //setMostrar(true);
                        event.target.value = '';
                    } else {
                        txtFechaNac.current.focus();
                    }
                }
            } else {
                return false;
            }

        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;//alert(e.which);
    };

    const validarPersona = (event) => {
        event.preventDefault();
        validaSoloNumero(event);
        //txtNomOrg.current.value = "";
        //txtNombreRep.current.value = "";
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {
                setContar(0);
                setTecla(event.which);
                //setActivate(true);
               


            } else {
                txtNombreUsuario.current.value = '';
            }
        }
    };

    const handlerClickTab = (index, lastIndex, event) => {
        //alert("Tab seleccionado: " + index + " .\ Tab anterior seleccionado: " + lastIndex);
        setTabIndex(index);
        /*if (index === 0){
            setTabIndex1(0);
        }*/

    };

    const handlerClickTab1 = (index, lastIndex, event) => {
        //alert("Tab seleccionado: " + index + " .\ Tab anterior seleccionado: " + lastIndex);
        setTabIndex1(index);
    }

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (txtLogin.current.value.trim() === '') {
            setTitulo('Error');
            setMsg('El Usuario no debe estar vacio');
            sigue = false;
            setTabIndex(0);
            txtLogin.current.focus();
        } else if (txtPassword.current.value.trim() === '' && operacion === 1) {
            setTitulo('Error');
            setMsg('La Contraseña no debe estar vacia');
            sigue = false;
            setTabIndex(0);
            txtPassword.current.focus();
        } else if (txtConfirmPassword.current.value.trim() === '' && operacion === 1) {
            setTitulo('Error');
            setMsg('La Confirmación de la Contraseña no debe estar vacia');
            sigue = false;
            setTabIndex(0);
            txtConfirmPassword.current.focus();
        } else if (txtPassword.current.value.trim() !== txtConfirmPassword.current.value.trim() && operacion === 1) {
            setTitulo('Error');
            setMsg('Las Contraseñas no coinciden');
            sigue = false;
            setTabIndex(0);
            txtConfirmPassword.current.focus();
        } else if (txtIdOrg.current.value.trim() === '') {
            setTitulo('Error');
            setMsg('El Código de la rganización no debe estar vacio');
            sigue = false;
            setTabIndex(0);
            txtIdOrg.current.focus();
        } else if (txtNomOrg.current.value.trim() === '') {
            setTitulo('Error');
            setMsg('El Nombre de la rganización no debe estar vacio');
            sigue = false;
            setTabIndex(0);
            txtNomOrg.current.focus();
        } else if (txtCedula.current.value.trim() === '') {
            setTitulo('Error');
            setMsg('La cedula no debe estar vacia');
            sigue = false;
            txtCedula.current.focus();
        } else if (txtNombreUsuario.current.value.trim() === '') {
            setTitulo('Error');
            setMsg('Los nombres no deben estar vacios');
            sigue = false;
            txtNombreUsuario.current.focus();
        } else if (txtApellidoUsuario.current.value.trim() === '') {
            setTitulo('Error');
            setMsg('Los Apellidos no deben estar vacio');
            sigue = false;
            txtApellidoUsuario.current.focus();
        } else if (txtDireccionUsuario.current.value.trim() === '') {
            setTitulo('Error');
            setMsg('La direccion del Usuario no debe estar vacia');
            sigue = false;
            txtDireccionUsuario.current.focus();
        } else if (txtFechaNac.current.value.trim() === '') {
            setTitulo('Error');
            setMsg('La fecha de nacimiento no debe estar vacia');
            sigue = false;
            txtFechaNac.current.focus();
        }


        if (sigue) {

            var user = [];
            var datoPer = [];
            user.push({
                idusuario: txtIdUsuario.current.value === '' ? '0' : txtIdUsuario.current.value,
                login: txtLogin.current.value,
                passwd: txtPassword.current.value,
                idorganizacion: txtIdOrg.current.value,
                liquidador: chkLiquidador.current.checked,
                persona: txtCedula.current.value,
                poseeimpresora: chkPoseeImpresora.current.checked,
                puerto: radioPuertoU.current.checked ? 0 : radioPuertoP.current.checked ? 1 : radioPuertoS.current.checked ? 2 : 1,
                accedocuenta: modulos.accedocuenta,
                accrenovalicencia: modulos.accrenovalicencia,
                acclicenciafunciona: modulos.acclicenciafunciona,
                accpermdecla: modulos.accpermdecla,
                accacreditacion: modulos.accacreditacion,
                accexoncomercio: modulos.accexoncomercio,
                accverifica: modulos.accverifica,
                accconfigcome: modulos.accconfigcome,
                accrepgensector: modulos.accrepgensector,
                accreppatente: modulos.accreppatente,
                accrepactividad: modulos.accrepactividad,
                accrepfecdecla: modulos.accrepfecdecla,
                accrepmondecla: modulos.accrepmondecla,
                accimppatente: modulos.accimppatente,
                accimpedoctasectcome: modulos.accimpedoctasectcome,
                accimptramites: modulos.accimptramites,
                acccontribuyente: permisos.acccontribuyente,
                accactividad: permisos.accactividad,
                accdeclaraciones: permisos.accdeclaraciones,
                accacticontri: permisos.accacticontri,
                accagente: permisos.accagente,
                accusuariocome: permisos.accusuariocome,
            })
            datoPer.push({
                apellidos: txtApellidoUsuario.current.value.trim().toUpperCase(),
                cedula: txtCedula.current.value,
                correoe: txtEmailUsuario.current.value,
                direccion: txtDireccionUsuario.current.value.trim().toUpperCase(),
                fnacimiento: txtFechaNac.current.value,
                nacionalidad: cmbNacionalidad.current.value,
                nombres: txtNombreUsuario.current.value.trim().toUpperCase(),
                sexo: cmbSexo.current.value,
                tlf1: txtTlfUsuario.current.value,
                tlf2: txtCelUsuario.current.value
            })
            setUsuario(user);
            setPersona(datoPer);
            //setOperaPer(operacionPer);
            //props.onHideAcepta(operacionPer, usu, repre, actixcome);
            //setMostrar7(true);
            setActivate(true);
            setContar2(0);
           
        } else {
            setMostrar(true);
        }

    };

    const mostrarPassword = () => setMostrarClave(!mostrarClave);
    const mostrarPassword1 = () => setMostrarClave1(!mostrarClave1);

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
                props.operacion < 3 ? txtIdOrg.current.focus() : btnAcepta.current.focus();
                setOperacion(props.operacion);
                setDeshabilitado(props.deshabilitado);
                setTabIndex(0);
                setTabIndex1(0);
                if (props.usuario) {
                    setModulos({
                        accedocuenta: props.usuario.usuarioByIdusuario.accedocuenta === null ? '0' : props.usuario.usuarioByIdusuario.accedocuenta,
                        accrenovalicencia: props.usuario.usuarioByIdusuario.accrenovalicencia === null ? '0' : props.usuario.usuarioByIdusuario.accrenovalicencia,
                        acclicenciafunciona: props.usuario.usuarioByIdusuario.acclicenciafunciona === null ? '0' : props.usuario.usuarioByIdusuario.acclicenciafunciona,
                        accpermdecla: props.usuario.usuarioByIdusuario.accpermdecla === null ? '0' : props.usuario.usuarioByIdusuario.accpermdecla,
                        accacreditacion: props.usuario.usuarioByIdusuario.accpermdecla === null ? '0' : props.usuario.usuarioByIdusuario.accpermdecla,
                        accexoncomercio: props.usuario.usuarioByIdusuario.accexoncomercio === null ? '0' : props.usuario.usuarioByIdusuario.accexoncomercio,
                        accverifica: props.usuario.usuarioByIdusuario.accverifica === null ? '0' : props.usuario.usuarioByIdusuario.accverifica,
                        accconfigcome: props.usuario.usuarioByIdusuario.accconfigcome === null ? '0' : props.usuario.usuarioByIdusuario.accconfigcome,
                        accrepgensector: props.usuario.usuarioByIdusuario.accrepgensector === null ? '0' : props.usuario.usuarioByIdusuario.accrepgensector,
                        accreppatente: props.usuario.usuarioByIdusuario.accreppatente === null ? '0' : props.usuario.usuarioByIdusuario.accreppatente,
                        accrepactividad: props.usuario.usuarioByIdusuario.accrepactividad === null ? '0' : props.usuario.usuarioByIdusuario.accrepactividad,
                        accrepfecdecla: props.usuario.usuarioByIdusuario.accrepfecdecla === null ? '0' : props.usuario.usuarioByIdusuario.accrepfecdecla,
                        accrepmondecla: props.usuario.usuarioByIdusuario.accrepmondecla === null ? '0' : props.usuario.usuarioByIdusuario.accrepmondecla,
                        accimppatente: props.usuario.usuarioByIdusuario.accimppatente === null ? '0' : props.usuario.usuarioByIdusuario.accimppatente,
                        accimpedoctasectcome: props.usuario.usuarioByIdusuario.accimpedoctasectcome === null ? '0' : props.usuario.usuarioByIdusuario.accimpedoctasectcome,
                        accimptramites: props.usuario.usuarioByIdusuario.accimptramites === null ? '0' : props.usuario.usuarioByIdusuario.accimptramites,
                    });
                    setPermisos({
                        acccontribuyente: props.usuario.usuarioByIdusuario.acccontribuyente === null ? '0000' : props.usuario.usuarioByIdusuario.acccontribuyente,
                        accactividad: props.usuario.usuarioByIdusuario.accactividad === null ? '0000' : props.usuario.usuarioByIdusuario.accactividad,
                        accdeclaraciones: props.usuario.usuarioByIdusuario.accdeclaraciones === null ? '000' : props.usuario.usuarioByIdusuario.accdeclaraciones,
                        accacticontri: props.usuario.usuarioByIdusuario.accacticontri === null ? '00' : props.usuario.usuarioByIdusuario.accacticontri,
                        accagente: props.usuario.usuarioByIdusuario.accagente === null ? '0000' : props.usuario.usuarioByIdusuario.accagente,
                        accusuariocome: props.usuario.usuarioByIdusuario.accusuariocome === null ? '0000' : props.usuario.usuarioByIdusuario.accusuariocome,
                    });
                } else {
                    setModulos({
                        accedocuenta: '0',
                        accrenovalicencia: '0',
                        acclicenciafunciona: '0',
                        accpermdecla: '0',
                        accacreditacion: '0',
                        accexoncomercio: '0',
                        accverifica: '0',
                        accconfigcome: '0',
                        accrepgensector: '0',
                        accreppatente: '0',
                        accrepactividad: '0',
                        accrepfecdecla: '0',
                        accrepmondecla: '0',
                        accimppatente: '0',
                        accimpedoctasectcome: '0',
                        accimptramites: '0',
                    });
                    setPermisos({
                        acccontribuyente: '0000',
                        accactividad: '0000',
                        accdeclaraciones: '000',
                        accacticontri: '00',
                        accagente: '0000',
                        accusuariocome: '0000',
                    });
                }

            }}
        >
            <Modal.Header style={{ backgroundColor: "rgb(106, 115, 123)" }}>
                <Modal.Title style={{ color: "#fff" }}>{operacion === 1 ? 'Agregar Usuario.' : operacion === 2 ? 'Editar Usuario.' : operacion === 3 ? 'Eliminar Usuario.' : 'Consultar Usuario.'}</Modal.Title>
                <button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body style={{ backgroundColor: "#0e5694", color: "#ffffff" }}>
                <Mensaje titulo={titulo} mensaje={msg}
                    show={mostrar}
                    onHide={handleCloseMensa} />
                <MensajeSiNo titulo={titulo2} mensaje={msg2}
                    show={mostrar1}
                    onHideNo={handleCloseNo} />
                <CatalogoOrganizacion titulo={titulo} mensaje={msg}
                    show={mostrar2}
                    onHideCancelaCatOrg={handleCloseCatalogo}
                    onHideAceptaCatOrg={handleAceptaCatalogo} />
                <CatalogoPersona titulo={titulo} mensaje={msg}
                    show={mostrar3}
                    onHideCancelaCatPer={handleCloseCatalogoPer}
                    onHideAceptaCatPer={handleAceptaCatalogoPer} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div style={{ height: "80vh", overflow: "auto" }}>
                    <Tabs
                        //scrollButtons="on"
                        selectedTabClassName="primary"
                        forceRenderTabPanel
                        //defaultIndex={0}
                        selectedIndex={tabIndex}
                        onSelect={handlerClickTab}

                    >
                        <TabList>
                            <Tab>Usuario</Tab>
                            <Tab>Permisos Aplicación Facturación</Tab>
                        </TabList>
                        <TabPanel>
                            {/* DATOS USUARIO */}
                            <div>
                                <div className="border border-primary rounded" style={{ padding: '10px' }}>
                                    <div className="form-row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-2">
                                                    <label htmlFor="validationTooltip01">Código: </label>
                                                    <input type="text" disabled={true} ref={txtIdUsuario} className="form-control form-control-sm" defaultValue={props.usuario ? props.usuario.usuarioByIdusuario.idusuario : ''} id="inputCodigo" onKeyUp={handleInputChange} />
                                                </div>
                                                <div className="col-md-6">
                                                    <label htmlFor="validationTooltipUsername">Usuario: </label>
                                                    <input type="text" autocomplete="off" disabled={operacion === 2 ? true : deshabilitado} ref={txtLogin} className="form-control form-control-sm" defaultValue={props.usuario ? props.usuario.usuarioByIdusuario.login : ''} id="inputLogin" onKeyUp={handleInputChange} />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label htmlFor="validationTooltip02">Contraseña: </label>
                                                    <div class="input-group">
                                                        <input type={mostrarClave ? 'text' : 'password'} disabled={operacion === 2 ? true : deshabilitado} ref={txtPassword} className="form-control form-control-sm" id="inputPassword" onKeyUp={handleInputChange} />
                                                        <span class="input-group-btn">
                                                            <button style={{ textAlign: "center", color: "white" }} disabled={operacion === 2 ? true : deshabilitado} onClick={mostrarPassword} className="btn btn-sm btn-info"><i disabled={deshabilitado} className="fa fa-eye-slash"></i> </button>
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <label htmlFor="validationTooltip03">Confirmar Contraseña: </label>
                                                    <div class="input-group">
                                                        <input type={mostrarClave1 ? 'text' : 'password'} disabled={operacion === 2 ? true : deshabilitado} ref={txtConfirmPassword} className="form-control form-control-sm" id="inputConfirmPassword" onKeyUp={handleInputChange} />
                                                        <span class="input-group-btn">
                                                            <button style={{ textAlign: "center", color: "white" }} disabled={operacion === 2 ? true : deshabilitado} onClick={mostrarPassword1} className="btn btn-sm btn-info"><i disabled={deshabilitado} className="fa fa-eye-slash"></i> </button>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <label htmlFor="inputDireccion">Organización </label>
                                <div className="border border-primary rounded" style={{ padding: '10px' }}>
                                    <div className="form-row" style={{ marginBottom: "10px" }}>
                                        <div className="col-md-3">
                                            <label htmlFor="inputTelefonoE">Código Organizacion:* </label>
                                            <input type="text" /*autocomplete="off"*/ style={{ width: "185px" }} disabled={deshabilitado} ref={txtIdOrg} className="form-control form-control-sm" id="inputIdOrg" defaultValue={props.usuario ? props.usuario.usuarioByIdusuario.idorganizacion : ''} onKeyUp={validarOrg} onBlur={validarOrg} />
                                        </div>
                                        <div className="col-md-1" style={{ marginTop: 'auto' }}>
                                            <button style={{ textAlign: "center", color: "white" }} disabled={deshabilitado} onClick={catalogoOrg} className="btn btn-sm btn-info"><i disabled={deshabilitado} className="fas fa-search"> Buscar</i> </button>
                                        </div>
                                        <div className="col-md-8">
                                            <label htmlFor="inputEmail1">Nombre: </label>
                                            <input type="text" disabled={true} ref={txtNomOrg} className="form-control form-control-sm" defaultValue={props.usuario ? props.usuario.usuarioByIdusuario.organizacionByIdorganizacion.razonsocial : ''} onKeyUp={handleInputChange} onBlur={handleInputChange} />
                                        </div>
                                    </div>
                                </div>
                                <label htmlFor="inputDireccion">Datos Personales del Usuario </label>
                                <div className="border border-primary rounded" style={{ padding: '10px' }}>
                                    <div className="form-row" >
                                        <div className="col-md-2">
                                            <label htmlFor="inputTelefonoE">Cédula: </label>
                                            <input type="text" disabled={deshabilitado} ref={txtCedula} className="form-control form-control-sm" id="inputCedula" defaultValue={props.datospersonales ? props.datospersonales.cedula : ''} onKeyUp={validarPersona} onBlur={validarPersona} />
                                        </div>
                                        <div className="col-md-1" style={{ marginTop: 'auto' }}>
                                            <button style={{ textAlign: "center", color: "white" }} disabled={deshabilitado} onClick={catalogoPer} className="btn btn-sm btn-info"><i disabled={deshabilitado} className="fas fa-search"> Buscar</i> </button>
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="inputEmail1">Nombres: </label>
                                            <input type="text" disabled={!habilitadoNU} ref={txtNombreUsuario} className="form-control form-control-sm" id="inputNomUsuario" defaultValue={props.datospersonales ? props.datospersonales.nombres.trim() : ''} onKeyUp={handleInputChange} onBlur={handleInputChange} />
                                        </div>
                                        <div className="col-md-5">
                                            <label htmlFor="inputEmail1">Apellidos: </label>
                                            <input type="text" disabled={!habilitadoNU} ref={txtApellidoUsuario} className="form-control form-control-sm" id="inputApeUsuario" defaultValue={props.datospersonales ? props.datospersonales.apellidos.trim() : ''} onKeyUp={handleInputChange} onBlur={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="form-row" >
                                        <div className="col-md-6">
                                            <label htmlFor="inputEmail1">Dirección: </label>
                                            <input type="text" disabled={!habilitadoNU} ref={txtDireccionUsuario} className="form-control form-control-sm" id="inputDireUsuario" defaultValue={props.datospersonales ? props.datospersonales.direccion.trim() : ''} onKeyUp={handleInputChange} onBlur={handleInputChange} />
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="inputEmail1">Correo Electronico: </label>
                                            <input type="text" disabled={!habilitadoNU} ref={txtEmailUsuario} className="form-control form-control-sm" id="inputEmailUsuario" defaultValue={props.datospersonales ? props.datospersonales.correoe !== null ? props.datospersonales.correoe.trim() : '' : ''} onKeyUp={handleInputChange} onBlur={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="form-row" >
                                        <div className="col-md-2">
                                            <label htmlFor="inputEmail1">Telefono: </label>
                                            <input type="text" disabled={!habilitadoNU} ref={txtTlfUsuario} className="form-control form-control-sm" id="inputTlfUsuario" placeholder="0000-0000000" defaultValue={props.datospersonales ? props.datospersonales.tlf1 !== null ? props.datospersonales.tlf1.trim() : '' : ''} onKeyUp={handleInputChange} onBlur={handleInputChange} />
                                        </div>
                                        <div className="col-md-2">
                                            <label htmlFor="inputEmail1">Celular: </label>
                                            <input type="text" disabled={!habilitadoNU} ref={txtCelUsuario} className="form-control form-control-sm" id="inputCelUsuario" placeholder="0000-0000000" defaultValue={props.datospersonales ? props.datospersonales.tlf2 !== null ? props.datospersonales.tlf2.trim() : '' : ''} onKeyUp={handleInputChange} onBlur={handleInputChange} />
                                        </div>
                                        <div className="col-md-3">
                                            <label htmlFor="inputFecha">Fecha de Nacimiento: </label>
                                            <input type="date" disabled={!habilitadoNU} ref={txtFechaNac} className="form-control form-control-sm" id="inputFechaNac" max={fechaSistema} defaultValue={props.datospersonales ? props.datospersonales.fnacimiento : ''} onKeyUp={handleInputChange} />
                                        </div>
                                        <div className="col-md-2">
                                            <label htmlFor="inputDireccion4">Nacionalidad: </label>
                                            <select name="" disabled={!habilitadoNU} ref={cmbNacionalidad} defaultValue={props.datospersonales ? props.datospersonales.nacionalidad : ''} className="form-control form-control-sm" >
                                                <option key="0" value="V">V</option>
                                                <option key="1" value="E">E</option>
                                            </select>
                                        </div>
                                        <div className="col-md-1">
                                            <label htmlFor="inputDireccion4">Sexo: </label>
                                            <select name="" disabled={!habilitadoNU} ref={cmbSexo} defaultValue={props.datospersonales ? props.datospersonales.sexo : ''} className="form-control form-control-sm" >
                                                <option key="0" value="M">M</option>
                                                <option key="1" value="F">F</option>
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="col-md-12" style={{ padding: '15px' }}></div>
                                            <input type="checkbox" readOnly style={{ marginRight: "3px" }} id="checLiquidador" disabled={deshabilitado} ref={chkLiquidador} defaultChecked={props.usuario ? props.usuario.usuarioByIdusuario.liquidador : false} /> Liquidador
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel>
                            {/* PERMISOS DE APLICACION  */}
                            <Tabs
                                //scrollButtons="on"
                                selectedTabClassName="primary"
                                forceRenderTabPanel
                                //defaultIndex={0}
                                selectedIndex={tabIndex1}
                                onSelect={handlerClickTab1}
                            >
                                <TabList>
                                    <Tab>Facturación</Tab>
                                    <Tab>Reportes</Tab>
                                    <Tab>Configuración</Tab>
                                </TabList>
                                <TabPanel>
                                    {/* Industria y Comercio */}
                                    <div>
                                        <div className="border border-primary rounded">
                                            <div className="container form-row">
                                                <div className="col-md-6 py-4">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            Facturación de Impuesto
                                                        </div>
                                                        <hr />
                                                        <div className="col-md-12">
                                                            <span className="border border-primary rounded" style={{ padding: '5px' }}>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="accedocuenta" disabled={deshabilitado} id="inlineRadio1" value={true} checked={modulos.accedocuenta === '1'} onChange={handleChangeOtro} />
                                                                    <label className="form-check-label" htmlFor="inlineRadio1">Disponible</label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="accedocuenta" disabled={deshabilitado} id="inlineRadio2" value={false} checked={modulos.accedocuenta === '0'} onChange={handleChangeOtro} />
                                                                    <label className="form-check-label" htmlFor="inlineRadio2">No disponible</label>
                                                                </div>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 py-4">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            Anular Facturas
                                                        </div>
                                                        <hr />
                                                        <div className="col-md-12">
                                                            <span className="border border-primary rounded" style={{ padding: '5px' }}>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="accedocuenta" disabled={deshabilitado} id="inlineRadio1" value={true} checked={modulos.accedocuenta === '1'} onChange={handleChangeOtro} />
                                                                    <label className="form-check-label" htmlFor="inlineRadio1">Disponible</label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="accedocuenta" disabled={deshabilitado} id="inlineRadio2" value={false} checked={modulos.accedocuenta === '0'} onChange={handleChangeOtro} />
                                                                    <label className="form-check-label" htmlFor="inlineRadio2">No disponible</label>
                                                                </div>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 py-4">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            Generar Facturas Especiales
                                                        </div>
                                                        <hr />
                                                        <div className="col-md-12">
                                                            <span className="border border-primary rounded" style={{ padding: '5px' }}>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="accedocuenta" disabled={deshabilitado} id="inlineRadio1" value={true} checked={modulos.accedocuenta === '1'} onChange={handleChangeOtro} />
                                                                    <label className="form-check-label" htmlFor="inlineRadio1">Disponible</label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="accedocuenta" disabled={deshabilitado} id="inlineRadio2" value={false} checked={modulos.accedocuenta === '0'} onChange={handleChangeOtro} />
                                                                    <label className="form-check-label" htmlFor="inlineRadio2">No disponible</label>
                                                                </div>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 py-4">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            Generar Facturas VIP
                                                        </div>
                                                        <hr />
                                                        <div className="col-md-12">
                                                            <span className="border border-primary rounded" style={{ padding: '5px' }}>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="accedocuenta" disabled={deshabilitado} id="inlineRadio1" value={true} checked={modulos.accedocuenta === '1'} onChange={handleChangeOtro} />
                                                                    <label className="form-check-label" htmlFor="inlineRadio1">Disponible</label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="accedocuenta" disabled={deshabilitado} id="inlineRadio2" value={false} checked={modulos.accedocuenta === '0'} onChange={handleChangeOtro} />
                                                                    <label className="form-check-label" htmlFor="inlineRadio2">No disponible</label>
                                                                </div>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 py-4">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            Reactivar Número
                                                        </div>
                                                        <hr />
                                                        <div className="col-md-12">
                                                            <span className="border border-primary rounded" style={{ padding: '5px' }}>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="accedocuenta" disabled={deshabilitado} id="inlineRadio1" value={true} checked={modulos.accedocuenta === '1'} onChange={handleChangeOtro} />
                                                                    <label className="form-check-label" htmlFor="inlineRadio1">Disponible</label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="accedocuenta" disabled={deshabilitado} id="inlineRadio2" value={false} checked={modulos.accedocuenta === '0'} onChange={handleChangeOtro} />
                                                                    <label className="form-check-label" htmlFor="inlineRadio2">No disponible</label>
                                                                </div>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </TabPanel>
                                <TabPanel>
                                    {/* Reportes */}
                                    <div>
                                        <div className="border border-primary rounded">
                                            <div className="container form-row">
                                                <div className="col-md-6 py-4">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            Listado de Facturas Emitidas
                                                        </div>
                                                        <hr />
                                                        <div className="col-md-12">
                                                            <span className="border border-primary rounded" style={{ padding: '10px' }}>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="accrepgensector" disabled={deshabilitado} id="inlineRadio1" value={true} checked={modulos.accrepgensector === '1'} onChange={handleChangeOtro} />
                                                                    <label className="form-check-label" htmlFor="inlineRadio1">Disponible</label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="accrepgensector" disabled={deshabilitado} id="inlineRadio2" value={false} checked={modulos.accrepgensector === '0'} onChange={handleChangeOtro} />
                                                                    <label className="form-check-label" htmlFor="inlineRadio2">No Disponible</label>
                                                                </div>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 py-4">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            Listado de Facturas por Cobrar
                                                        </div>
                                                        <hr />
                                                        <div className="col-md-12">
                                                            <span className="border border-primary rounded" style={{ padding: '10px' }}>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="accreppatente" disabled={deshabilitado} id="inlineRadio1" value={true} checked={modulos.accreppatente === '1'} onChange={handleChangeOtro} />
                                                                    <label className="form-check-label" htmlFor="inlineRadio1">Disponible</label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="accreppatente" disabled={deshabilitado} id="inlineRadio2" value={false} checked={modulos.accreppatente === '0'} onChange={handleChangeOtro} />
                                                                    <label className="form-check-label" htmlFor="inlineRadio2">No disponible</label>
                                                                </div>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 py-4">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            Listado de Facturas Cobradas
                                                        </div>
                                                        <hr />
                                                        <div className="col-md-12">
                                                            <span className="border border-primary rounded" style={{ padding: '10px' }}>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="accrepactividad" disabled={deshabilitado} id="inlineRadio1" value={true} checked={modulos.accrepactividad === '1'} onChange={handleChangeOtro} />
                                                                    <label className="form-check-label" htmlFor="inlineRadio1">Disponible</label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="accrepactividad" disabled={deshabilitado} id="inlineRadio2" value={false} checked={modulos.accrepactividad === '0'} onChange={handleChangeOtro} />
                                                                    <label className="form-check-label" htmlFor="inlineRadio2">No Disponible</label>
                                                                </div>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 py-4">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            Listado de Facturas Anuladas
                                                        </div>
                                                        <hr />
                                                        <div className="col-md-12">
                                                            <span className="border border-primary rounded" style={{ padding: '10px' }}>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="accrepactividad" disabled={deshabilitado} id="inlineRadio1" value={true} checked={modulos.accrepactividad === '1'} onChange={handleChangeOtro} />
                                                                    <label className="form-check-label" htmlFor="inlineRadio1">Disponible</label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="accrepactividad" disabled={deshabilitado} id="inlineRadio2" value={false} checked={modulos.accrepactividad === '0'} onChange={handleChangeOtro} />
                                                                    <label className="form-check-label" htmlFor="inlineRadio2">No Disponible</label>
                                                                </div>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 py-4">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            Listado de Facturas por Tipo de Impuesto
                                                        </div>
                                                        <hr />
                                                        <div className="col-md-12">
                                                            <span className="border border-primary rounded" style={{ padding: '10px' }}>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="accrepactividad" disabled={deshabilitado} id="inlineRadio1" value={true} checked={modulos.accrepactividad === '1'} onChange={handleChangeOtro} />
                                                                    <label className="form-check-label" htmlFor="inlineRadio1">Disponible</label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="accrepactividad" disabled={deshabilitado} id="inlineRadio2" value={false} checked={modulos.accrepactividad === '0'} onChange={handleChangeOtro} />
                                                                    <label className="form-check-label" htmlFor="inlineRadio2">No Disponible</label>
                                                                </div>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </TabPanel>
                                <TabPanel>
                                    {/* Configuración */}
                                    <div>
                                        <div className="border border-primary rounded">
                                            <div className="container form-row">
                                                <div className="col-md-7 py-4">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            Módulo de Usuarios
                                                        </div>
                                                        <hr />
                                                        <div className="col-md-12">
                                                            <span className="border border-primary rounded" style={{ padding: '10px' }}>
                                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkUsuarioComeConsul" name="accusuariocome" disabled={deshabilitado} checked={permisos.accusuariocome.toString().substring(0, 1) === '1'} onChange={handleChangeChek} />Consultar
                                                                <a> &nbsp; </a>
                                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkUsuarioComeInc" name="accusuariocome" disabled={deshabilitado} checked={permisos.accusuariocome.toString().substring(1, 2) === '1'} onChange={handleChangeChek} />Incluir
                                                                <a> &nbsp; </a>
                                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkUsuarioComeEdit" name="accusuariocome" disabled={deshabilitado} checked={permisos.accusuariocome.toString().substring(2, 3) === '1'} onChange={handleChangeChek} />Editar
                                                                <a> &nbsp; </a>
                                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkUsuarioComeElim" name="accusuariocome" disabled={deshabilitado} checked={permisos.accusuariocome.toString().substring(3, 4) === '1'} onChange={handleChangeChek} />Eliminar
                                                                <a> &nbsp; </a>
                                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkUsuarioComeTodo" name="accusuariocome" disabled={deshabilitado} checked={permisos.accusuariocome.toString() === '1111'} onChange={handleChangeChek} />Todas
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-5 py-4">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            Configuración del Modulo
                                                        </div>
                                                        <hr />
                                                        <div className="col-md-12">
                                                            <span className="border border-primary rounded" style={{ padding: '10px' }}>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="accconfigcome" disabled={deshabilitado} id="inlineRadio1" value={true} checked={modulos.accconfigcome === '1'} onChange={handleChangeOtro} />
                                                                    <label className="form-check-label" htmlFor="inlineRadio1">Disponible</label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="accconfigcome" disabled={deshabilitado} id="inlineRadio2" value={false} checked={modulos.accconfigcome === '0'} onChange={handleChangeOtro} />
                                                                    <label className="form-check-label" htmlFor="inlineRadio2">No Disponible</label>
                                                                </div>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 py-4">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            Impresora
                                                        </div>
                                                        <hr />
                                                        <div className="col-md-12">
                                                            <span className="border border-primary rounded" style={{ padding: '10px' }}>
                                                                <input type="checkbox" style={{ marginRight: "3px" }} id="chkPoseeImpresora" name="poseeimpresora" ref={chkPoseeImpresora} disabled={deshabilitado} defaultChecked={props.usuario ? props.usuario.usuarioByIdusuario.poseeimpresora : false} />Posee Impresora
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 py-4">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            Puerto
                                                        </div>
                                                        <hr />
                                                        <div className="col-md-12">
                                                            <span className="border border-primary rounded" style={{ padding: '10px' }}>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="radioPuerto" value="0" id="radioUSB" ref={radioPuertoU} disabled={deshabilitado} defaultChecked={props.usuario ? props.usuario.usuarioByIdusuario.puerto === "0" ? true : false : false} />
                                                                    <label className="form-check-label" htmlFor="inlineRadio1">USB </label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="radioPuerto" value="1" id="radioParalelo" ref={radioPuertoP} disabled={deshabilitado} defaultChecked={props.usuario ? props.usuario.usuarioByIdusuario.puerto === "1" ? true : false : false} />
                                                                    <label className="form-check-label" htmlFor="inlineRadio2">Paralelo</label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="radioPuerto" value="2" id="radioSerial" ref={radioPuertoS} disabled={deshabilitado} defaultChecked={props.usuario ? props.usuario.usuarioByIdusuario.puerto === "2" ? true : false : false} />
                                                                    <label className="form-check-label" htmlFor="inlineRadio2">Serial</label>
                                                                </div>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </TabPanel>
                            </Tabs>
                        </TabPanel>
                    </Tabs>
                </div>
            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "rgb(106, 115, 123)" }}>
                <button ref={btnAcepta} onClick={onChangeValidar} className="btn btn-primary col-md-2"><i className="fas fa-check-circle">  Aceptar</i></button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-danger col-md-2"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}